(function() {
	'use strict';

	angular.module('paymentRates').controller('PaymentRatesCtrl',
			PaymentRatesCtrl);

	function PaymentRatesCtrl(CommonMasterData, $sce, PopupManager,
			EventManagerService, PaymentRatesService, MessageService) {
		var vm = this;
		vm.model = {
			searchPanelToggle : true,
			searchCriteria : "",
			crewTypes : [],
			showFlyingHourDetails : false,
			showOtherPaymentDetails : false,
			flyingRangeDetails : [],
			otherPaymentDetails : []
		};

		loadCrewTypes();
		
		function loadCrewTypes() {
			// load crew Types
			CommonMasterData.getCrewTypeList(function(crewTypes) {
				vm.model.crewTypes = crewTypes;
			}, function() {
				console.log('Crew type retrieval error');
			});
		}

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
		};

		// submit search
		vm.onSearchClicked = function(params) {
			vm.model.searchCriteria = params;
			getFlyingHourRates(vm.model.searchCriteria);
			getOtherPaymentRates(vm.model.searchCriteria);
		};

		function getFlyingHourRates(param) {
			PaymentRatesService.getFlyingHourRates(param, function(response) {
				vm.model.flyingRangeDetails = response;
				vm.model.searchPanelToggle = false;
				vm.model.showFlyingHourDetails = true;
			}, function(error) {
				vm.model.showFlyingHourDetails = false;
				MessageService.error(error);
			});
		}

		function getOtherPaymentRates(param) {
			PaymentRatesService.getOtherPaymentRates(param, function(response) {
				vm.model.otherPaymentDetails = response;
				vm.model.showOtherPaymentDetails = true;
			}, function(error) {
				MessageService.error(error);
				vm.model.showOtherPaymentDetails = false;
			});
		}

		vm.onClickSaveButton = function() {
			EventManagerService
					.notifyEventListeners(EventManagerService.EVENT.PAYMENT_RATES.SAVE_RANGE);
		}

		vm.saveOtherPaymentDetails = function(param) {
			if(param.length != 0){
				PaymentRatesService.saveOtherPaymentRates(param,
						function(response) {
					if (response.success) {
						getOtherPaymentRates(param.crewType);
						MessageService.success("Data saved successfully");
					} else {
						MessageService.error(errors[0]);
					}
				}, function(error) {
					MessageService.error(error);
				});
			}
		}

		vm.saveFlyingHoursDetails = function(param) {
			PaymentRatesService.saveFlyingHourRates(param, function(response) {
				if (response.success) {
					getFlyingHourRates(param.crewTypeCode);
					PopupManager.closeModal('ADD_FLYING_HOURS_RANGE');
					MessageService.success("Data saved successfully");
				} else {
					MessageService.error(errors[0]);
				}
			}, function(error) {
				MessageService.error(error);
			});
		}

		vm.deleteFlyingHoursDetail = function(param) {

			var details = {
				title : 'Confirmation',
				messages : [ MessageService.MESSAGES.PAYMENT_RATES.DELETE_CONFIRMATION ]
			};
			PopupManager.openModal('CONFIRM_DIALOG', details, confirmDailogue);

			function confirmDailogue(pass) {
				if (pass == 'YES') {
					PaymentRatesService
							.deleteFlyingHourRates(
									param,
									function(response) {
										if (response.success) {
											getFlyingHourRates(param.crewTypeCode);
											PopupManager
													.closeModal('ADD_FLYING_HOURS_RANGE');
											MessageService
													.success(MessageService.MESSAGES.PAYMENT_RATES.DELETE_SUCCESS);
										} else {
											MessageService.error(errors[0]);
										}
									}, function(error) {
										MessageService.error(error);
									});
				} else {
					MessageService
							.success(MessageService.MESSAGES.PAYMENT_RATES.DELETE_CANCEL);
				}
			}

		};

	}
}());
